<template>
  <div class="col col-12 md:col-6 ">
    <span v-if="(!checkIsContactRole) && isSpecialRequest">
      <div class="grid field mb-0">
        <label
          for="duration-effective-number"
          class="col-12 mb-2 md:col-5 md:mb-0 required-input"
        >{{
          $t('appointmentPage.control.effectiveDuration')
        }}</label>
        <div class="col-12 md:col-6">
          <InputNumber
            id="duration-effective-number"
            v-model="v$.durationInserted.$model"
            type="number"
            :min="1"
            :max="16"
            show-buttons
          />
        </div>
      </div>
    </span>
    <span v-else>
      {{ $t('appointmentPage.control.estimatedDuration') }}
      {{ controlDurationString }}
    </span>
  </div>
</template>

<script>
import {convertMinsToHrsMinsString} from "@/shared/utils/dateTimeUtils";
import {useVuelidate} from "@vuelidate/core";
import InputNumber from 'primevue/inputnumber';
import {minValue, required} from "@/i18n/i18nValidators";
import {CONTACT_ROLE} from "@/shared/constants";

export default {
  name: 'RequestRemainingDurationInput',
  components: {InputNumber},
  props: {
    controlDuration: {
      type: Number,
      required: true
    },
    modelValue: {
      type: Number,
      default: 0
    },
    isSpecialRequest: {
      type: Boolean,
      default: false
    }
  },
  emits: ['update:modelValue', 'durationChanged'],
  setup() {
    return {
      v$: useVuelidate()
    }
  },
  validations() {
    return {
      durationInserted: {required, minValue: minValue(1)},
    }
  },
  data() {
    return {
      durationInserted: this.modelValue,
      controlDurationReceived: this.controlDuration,
      controlDurationCurrent: this.controlDuration,
      firstMountedComponent: false,
    }
  },
  computed: {
    controlDurationString() {
      return convertMinsToHrsMinsString(this.controlDuration)
    },
    checkIsContactRole(){
     return this.$store.state.auth.user.role === CONTACT_ROLE;
    },
   checkIsSpecialRequest(){
      return this.isSpecialRequest;
    },
  },
  mounted() {
    this.$watch('durationInserted', () => {
      if (this.v$.durationInserted.$invalid) {
        this.$emit('update:modelValue', 1)
      } else {
        this.$emit('update:modelValue', this.controlDuration)
      }
      this.$emit('durationChanged', this.durationInserted);
    })
  },
}
</script>

<style lang="scss" scoped>
.remaining-duration {
  color: $pink;
  font-weight: 600;
}
</style>
